import { Button, FormHelperText, InputLabel } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@mui/material/Typography'
import { useState } from 'react'

const styles = makeStyles(theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  label: {
    color: '#000000 !important',
    fontWeight: 'bold !important'
  },
  fileInfo: {
    padding: 8,
    background: '#f5f5f5',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    borderRadius: 8,
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 200,
  },
  errorText: {
    color: theme.palette.error.main,
  },
} ))

export default function InputFile({ label, required=false, name, onChange, helperText }) {
  const classes = styles()
  const [selectedFile, setSelectedFile] = useState(null)
  const [showError, setShowError] = useState(false)

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    setSelectedFile(file)
    setShowError(false)
    if (onChange) {
      onChange(event)
    }
  }

  const handleFileRemove = () => {
    setSelectedFile(null)
    if (onChange) {
      onChange({ target: { value: '', name } }) // Send an empty event to clear the value
    }
  }

  const handleFormSubmit = (event) => {
    if (required && !selectedFile) {
      setShowError(true)
      event.preventDefault()
    }
  }
  return (
    <form className={classes.form} onSubmit={handleFormSubmit}>
      <div className={classes.container}>
        <InputLabel className={classes.label} required={required}>
          {label}
        </InputLabel>
        <Button
          fullWidth
          variant="contained"
          component="label"
          sx={{ display: selectedFile ? 'none' : 'block', textAlign: 'center'}}
        >
          Upload File
          <input
            required={required}
            type="file"
            hidden
            onChange={handleFileChange}
          />
        </Button>
        {showError && (
          <FormHelperText className={classes.errorText}>
            {helperText || 'You must upload a file.'}
          </FormHelperText>
        )}
        {selectedFile && (
          <div className={classes.fileInfo}>
            <Typography variant="body2" className={classes.fileName}>{selectedFile.name}</Typography>
            <Button variant="outlined" size="small" color="error" onClick={handleFileRemove}>
              Supprimer
            </Button>
          </div>
        )}
      </div>
    </form>
  )
}
